import { connect } from 'react-redux'
import AccountCard from '../../components/Settings/AccountCard'

const mapStateToProps = ({ auth }) => ({
  user      : auth.user,
  inProfile : true
})

export default connect(mapStateToProps)(AccountCard)
